import api, { checkTokenErrorResponse } from '..';

const languages = [
    ['en-US', 'English'],
    ['pt-br', 'Português']
]

const timezones = [
    [1, "America/New_York"],
    [2, "America/Chicago"],
    [3, "America/Denver"],
    [4, "America/Los_Angeles"],
    [5, "America/Phoenix"],
    [6, "America/Puerto_Rico"],
    [7, "America/Honolulu"],
    [8, "America/Sao_Paulo"],
    [9, "America/Rio_Branco"],
    [10, "America/Manaus"],
    [11, "America/Noronha"],
]
export async function getAcademyInfos() {
    return api.get(`academias/info/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function getAcademies() {
    return api.get(`academias/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function getAcademy(id) {
    return api.get(`academias/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function postAcademy(email, password, nome, idioma = 'en-US', timezone = 'America/Sao_Paulo', iso2_ddi = null, ddi = null, telefone = null, logradouro = null, numero = 0,cidade = null, logo = null ) {
    const formdata = new FormData();
    formdata.append('email', email);
    formdata.append('password', password);

    formdata.append("nome", nome);
    formdata.append("idioma", idioma);
    formdata.append("timezone", timezone);
    formdata.append("iso2_ddi", iso2_ddi);
    formdata.append("ddi", ddi);
    formdata.append("telefone", telefone);
    formdata.append("logradouro", logradouro);
    formdata.append("numero", numero);
    formdata.append("cidade", cidade);
    if (logo !== null)
        formdata.append("logo", logo);
    
    return api.post("academias/", formdata)
    .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function patchAcademy(id, email, password = "", nome, idioma = 'en-US', timezone = 'America/Sao_Paulo', iso2_ddi = null, ddi = null, telefone = null, logradouro = null, numero = 0,cidade = null, logo = null ) {
    const formdata = new FormData();

    formdata.append("nome", nome);
    formdata.append("idioma", idioma);
    formdata.append("timezone", timezone);
    formdata.append("iso2_ddi", iso2_ddi);
    formdata.append("ddi", ddi);
    formdata.append("telefone", telefone);
    formdata.append("logradouro", logradouro);
    formdata.append("numero", numero);
    formdata.append("cidade", cidade);
    formdata.append("email", email);
    if(password !== "")
        formdata.append("password", password);
    if (logo !== null)
        formdata.append("logo", logo);
    
    return api.patch(`academias/${id}/`, formdata)
    .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function deleteAcademy(id) {
    return api.delete(`academias/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function disableAcademy(id) {
    return api.patch(`academias/${id}/desativar_academia/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function activateAcademy(id) {
    return api.patch(`academias/${id}/ativar_academia/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}


export async function patchAcademyPassword(id, password) {
    
    return api.patch(`academias/${id}/`, {password})
    .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

const academyServices = {
    getAcademyInfos,
    getAcademies,
    getAcademy,
    postAcademy,
    deleteAcademy,
    patchAcademy,
    disableAcademy,
    activateAcademy,
    patchAcademyPassword,
    languages,
    timezones,
}
export default academyServices;